//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'Ideal_height_prediction_formula',
  data() {
    return {
      form: {
        motherHeight: '',
        fatherHeight:''
      },
      hasScore: false,
      disabled: false,
      num: '',
      num1: ''
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        self.hasScore = true;
        self.num = ((form.motherHeight * 1.08 + form.fatherHeight)/2).toFixed(2)
        self.num1 = ((form.fatherHeight * 0.923 + form.motherHeight)/2).toFixed(2)
        return String(self.num,self.num1)
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Ideal_height_prediction_formula.vue